module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/postauth-8633c64f95af914f9c5977cd55e8cd75.svg";